/**
 * Custom Store Hero Page Section Script
 * Custom Element: <custom-store-hero>
 */

class CustomStoreHero extends HTMLElement {
  constructor() {
    super();
    this.section = null;
    this.scrollIndicator = null;
  }

  connectedCallback() {
    this.section = this.closest('.shopify-section') || this;
    this.scrollIndicator = this.querySelector('.store-hero__scroll-indicator');

    // Attach scroll indicator event listener
    if (this.scrollIndicator) {
      this.scrollIndicator.addEventListener('click', this.scrollToNextSection.bind(this));
    }

    // Trigger animations
    if (this.classList.contains('store-hero--animate-on')) {
      this.triggerEntranceAnimation();
    }

    // Shopify Theme Editor design mode listeners
    document.addEventListener('shopify:section:load', this.handleThemeEditorLoad.bind(this));
    document.addEventListener('shopify:section:select', this.handleThemeEditorSelect.bind(this));
  }

  disconnectedCallback() {
    if (this.scrollIndicator) {
      this.scrollIndicator.removeEventListener('click', this.scrollToNextSection.bind(this));
    }
    document.removeEventListener('shopify:section:load', this.handleThemeEditorLoad.bind(this));
    document.removeEventListener('shopify:section:select', this.handleThemeEditorSelect.bind(this));
  }

  scrollToNextSection(event) {
    event.preventDefault();
    if (this.section) {
      const nextSection = this.section.nextElementSibling;
      if (nextSection) {
        // Scroll to the top of the next section block
        nextSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      } else {
        // Fallback: Scroll past this hero height
        const rect = this.getBoundingClientRect();
        const scrollPosition = window.scrollY + rect.height;
        window.scrollTo({
          top: scrollPosition,
          behavior: 'smooth'
        });
      }
    }
  }

  triggerEntranceAnimation() {
    // Add is-visible class after a small paint frame delay to ensure transition triggers
    requestAnimationFrame(() => {
      setTimeout(() => {
        this.classList.add('is-visible');
      }, 50);
    });
  }

  handleThemeEditorLoad(event) {
    if (event.detail.sectionId === this.getSectionId()) {
      if (this.classList.contains('store-hero--animate-on')) {
        this.classList.remove('is-visible');
        this.triggerEntranceAnimation();
      }
    }
  }

  handleThemeEditorSelect(event) {
    if (event.detail.sectionId === this.getSectionId()) {
      if (this.classList.contains('store-hero--animate-on')) {
        this.classList.remove('is-visible');
        this.triggerEntranceAnimation();
      }
    }
  }

  getSectionId() {
    if (this.section && this.section.id) {
      return this.section.id.replace('shopify-section-', '');
    }
    return '';
  }
}

// Define the custom element if not already registered
if (!customElements.get('custom-store-hero')) {
  customElements.define('custom-store-hero', CustomStoreHero);
}
